/**
 * Format a quantity for UI: whole numbers without decimals; otherwise up to 2 decimal places (no trailing zeros).
 * Pass coalesced numbers at the call site (e.g. value ?? 0) when the UI should show 0 instead of blank.
 * @param {unknown} value
 * @param {{ itemType?: 'part' | 'service', forceInteger?: boolean }} [opts]
 */
export function formatQuantityDisplay(value, opts = {}) {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  const forceInteger = opts.forceInteger || opts.itemType === 'part';
  if (forceInteger) {
    const i = Math.trunc(n);
    return String(Math.max(0, i));
  }
  const rounded = Math.round(n * 100) / 100;
  return parseFloat(rounded.toFixed(2)).toString();
}

/**
 * Controlled TextField value for line-item qty while editing.
 * Parts: non-negative integers only (no 3.000). Services: raw string while typing decimals; otherwise formatted.
 */
export function formatLineItemQtyEditValue(itemType, raw) {
  const isService = String(itemType || 'part').toLowerCase() === 'service';
  if (raw === '' || raw === null || raw === undefined) return '';
  if (isService) {
    const s = String(raw).trim();
    if (s === '' || s === '.' || s === '-' || s === '-.') return s;
    if (/^-?\d+\.$/.test(s) || /^-?\d+\.\d{0,2}$/.test(s)) return s;
    const n = Number(raw);
    if (!Number.isFinite(n)) return s;
    return formatQuantityDisplay(n, { itemType: 'service' });
  }
  const n = Number(raw);
  if (!Number.isFinite(n)) return '';
  return String(Math.max(0, Math.trunc(Math.round(n))));
}
